<template>
  <div class="navbar-bottom" :class="{'iphone-x': iphoneX}" v-if="dataLoaded">
    <div class="nav" :class="{'active': index == activeIndex}" v-for="(nav, index) in navs" @click="jump(nav)">
      <div class="nav-image">
        <beast-image class="normal-img" :src="nav.normalIcon"/>
        <beast-image class="active-img" :src="nav.activeIcon"/>
      </div>
      <div class="nav-text">{{nav.title}}</div>
    </div>
  </div>
</template>

<script>
  import browser from '@beastshop/browser'
  import bridge from '@beastshop/bridge'
  import axios from '@/axios-mock'
  import { transformLink, trackSkip } from '@/link'
  import { isIphoneX } from '@/util'

  import beastImage from '@/components/image'
  

  const app = browser.app()

  export default {
    name: 'navbar-bottom',
    props: ['activeIndex'],
    data() {
      return {
        navs: [],
        dataLoaded: false,
        iphoneX: isIphoneX()
      }
    },
    components: {
      beastImage
    },
    created(){
      if(browser.app()) {
        return
      }
      this.getData()
        .then(({ data }) => {
          this.navs = data.navs
          this.dataLoaded = true
        })

      if (this.iphoneX) {
        if (!browser.app()) {
          this.iphoneX = false
        }
        window.onresize = () => {
          this.iphoneX = !this.iphoneX
        }
      }
    },
    methods: {
      getData () {
        return Promise.resolve(require('./test/data'))
        return axios({
          url: ''
        })
      },
      jump (nav) {
        // sa.track('NavigationBar', {
        //   navigation_location: '底部'
        // })
        const link = transformLink({
          link: nav.link,
          title: nav.title
        })
        if (link === '' || link === '#') {
          return
        } else {
          window.location.href = link
        }
      }
    }
  }
</script>

<style lang="stylus">
  @import '../../common/styl/global.styl'
  .navbar-bottom
    position fixed
    width 100%
    height rem(navbar-bottom-height)
    box-sizing border-box
    border-top border-style
    background #fff
    left 0
    bottom 0
    z-index 100
    clearfix()
    &.iphone-x
      height rem(iphonex-navbar-bottom-height)
    .nav
      width 20%
      float left
      height 100%
      position relative
      text-align center
      // padding-top rem(5)
      box-sizing border-box
      .nav-image
        position absolute
        width rem(28)
        height rem(28)
        top rem(5)
        left 50%
        transform translateX(-50%)
        img
          width 100%
          height 100%
        .active-img
          display none
      .nav-text
        position absolute
        top rem(34)
        left 50%
        transform translateX(-50%)
        font-size rem(9)
        color #BFBFBF
        font-weight bold
      &.active
        .active-img
          display block
        .normal-img
          display none
        .nav-text
          color #2B2B2B

</style>



// WEBPACK FOOTER //
// index.vue?c43b6b1c